module.exports = __webpack_public_path__ + "img/linkedin.e6894d99.svg";